import type { SVGProps } from 'react';
export const Vimeo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fill="#19B2E5"
      d="M14.96 4Q12.04 3.9 11 7.53q.54-.25 1.04-.25c2.46 0-.57 5.05-1.32 5.05-.89 0-1.42-4.5-1.6-5.74q-.39-2.56-2.01-2.4-.7.07-2.08 1.35L3 7.5l.66.9q.95-.7 1.1-.7c1.8 0 1.68 9.3 4.54 9.3 2.74 0 7.57-7.13 7.69-10q.12-2.94-2.03-3"
    />
  </svg>
);
